import { Box, Typography } from "@mui/material";
import { useContext } from "react";
import { GlobalContext } from "../../../../common/Context";

const SponsorCard = ({ sponsorData }) => {
  const { mobileView, tabletView } = useContext(GlobalContext);
  const DEFAULT_DESC = (brandName) =>
    `${brandName} is proud to be a sponsor of the Safe Roads Challenge. More information about our involvement will be available soon. Together, we are dedicated to championing safer roads and fostering a culture of responsible driving.`;
  const containerStyle = {
    display: "flex",
    alignItems: "center",
    paddingY: "2.5rem",
    borderTop: "1px solid #747474",
    flexWrap: (mobileView || tabletView) && "wrap",
  };
  const imgStyle = {
    width: mobileView ? "6rem" : "9rem",
    mr: "1.5rem",
    borderRadius: "8px",
  };
  const nameStyle = {
    mb: !mobileView && !tabletView && "0.75rem",
    fontSize: mobileView || tabletView ? "1.75rem" : "1.5rem",
    fontWeight: 800,
    width: sponsorData.iconUrl
      ? mobileView
        ? "calc(100% - 7.5rem)"
        : tabletView
        ? "calc(100% - 10.5rem)"
        : "auto"
      : "auto",
  };
  const desktopTextContainer = {
    ml: !sponsorData.iconUrl && "10.5rem",
  };
  const descStyle = {
    width: mobileView || tabletView ? "100%" : "auto",
    mt: (mobileView || tabletView) && "1rem",
    lineHeight: 1.5,
  };

  const NameAndDesc = () => {
    return (
      <>
        <Typography variant="h2" sx={nameStyle}>
          {sponsorData.companyName.toUpperCase()}{" "}
          {!sponsorData.iconUrl && "(No Active Logo)"}
        </Typography>
        <Typography sx={descStyle}>
          {sponsorData.srcStatement
            ? sponsorData.srcStatement
            : DEFAULT_DESC(sponsorData.companyName)}
        </Typography>
      </>
    );
  };

  return (
    <Box sx={containerStyle}>
      {sponsorData.iconUrl && (
        <Box
          component="img"
          sx={imgStyle}
          src={sponsorData.iconUrl}
          alt={sponsorData.companyName + " logo"}
        />
      )}

      {!mobileView && !tabletView ? (
        <Box sx={desktopTextContainer}>
          <NameAndDesc />
        </Box>
      ) : (
        <NameAndDesc />
      )}
    </Box>
  );
};

export default SponsorCard;
